// extracted by mini-css-extract-plugin
export default {"faqItem":"FAQItem_faqItem__muKwI","category":"FAQItem_category__0npuS","question":"FAQItem_question__H6hcf","answer":"FAQItem_answer__2-IGk"};